"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.collectionUpdatedEventMapper = exports.collectionEventMapper = void 0;
var mappers_1 = require("../products/mappers");
exports.collectionEventMapper = function (item) {
    return {
        _id: item.collectionId,
        name: item.name,
        mainMedia: (item.media || null) && mappers_1.buildImageUrl(item.media.mainMedia),
    };
};
exports.collectionUpdatedEventMapper = function (item) {
    return {
        collectionId: item.collectionId,
        updatedFields: item.changedFields,
    };
};
//# sourceMappingURL=collectionEvent.mapper.js.map